import { anyAsciiCode } from "../../../../_base/helper/AnyAscii";

/** Chuẩn hoá mã quét: bỏ khoảng trắng hai đầu, bỏ dấu tiếng Việt, viết hoa (như trang xuất bán) */
export const normalizeSerial = (raw: string | null | undefined): string =>
  anyAsciiCode(String(raw ?? "").trim()).toLocaleUpperCase();
